import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/auth/sign-up-requests/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const signUpRequest = {
  post: apiPathFunc(pathBase),
};
